import Vue from "vue"

export default Vue.extend({
  methods: {
    scrollToSelf(offset = 0) {
      //@ts-ignore
      const container = window.document.getElementById(this._uid)

      if (container) {
        const containerOffset = container.getBoundingClientRect().top
        const documentOffset = window.document
          .getElementsByTagName("body")[0]
          .getBoundingClientRect().top

        window.scrollTo({
          top: containerOffset - documentOffset - offset,
          left: 0,
          behavior: "smooth",
        })
      }
    },
  },
})
